import React, { useEffect, useState } from 'react';
import videojs from 'video.js';
import HlsQualitySelector from '../quality_selector/hlsQualitySelector';
import mobileUi from '../mobile_ui/MobileUi';
import '../quality_selector/quality_button.css';
import '../mobile_ui/mobile-ui.css';
import 'video.js/dist/video-js.css';
import 'videojs-contrib-quality-levels';

const CustomVideoPlayer = ({
  options,
  logger,
  playerWrapperRef = {},
  lockAfterSeconds = 0,
  seekTime = 0,
  onEnd = () => {},
  onLock = (_unlockToTimestamp) => {},
}) => {
  const [player, setPlayer] = useState(null);

  const handleVideoContainerRef = (container) => {
    if (!container || player) return;

    const videoElement = document.createElement('video-js');
    container.appendChild(videoElement);

    const newPlayer = videojs(videoElement, options, () => {
      if (playerWrapperRef) {
        const value = {
          container,
          play: () => newPlayer.play(),
          pause: () => newPlayer.pause(),
          currentTimestamp: () => newPlayer.currentTime(),
          videoDuration: () => newPlayer.duration(),
        };
        if (typeof playerWrapperRef === 'function') {
          playerWrapperRef(value);
        } else {
          playerWrapperRef.current = value;
        }
      }

      var consideredWatched = false;
      var hasLoggedPlay = false;
      newPlayer.on('play', () => {
        if (!hasLoggedPlay) {
          hasLoggedPlay = true;
          logger.logPlay?.();
        }
      });
      newPlayer.on('timeupdate', () => {
        var totalWatched = 0;
        for (let i = 0; i < newPlayer.played().length; i++) {
          totalWatched +=
            newPlayer.played().end(i) - newPlayer.played().start(i);
        }

        if (totalWatched >= 15 && !consideredWatched) {
          consideredWatched = true;
          logger.logWatch();
        }

        if (lockAfterSeconds > 0) {
          if (totalWatched > lockAfterSeconds) {
            newPlayer.pause();
            onLock(newPlayer.currentTime());
          }
        }
      });

      newPlayer.on('ended', () => {
        onEnd();
      });

      newPlayer.addClass('vjs-hls-quality-selector');
      new HlsQualitySelector(newPlayer, { displayCurrentQuality: true });
      mobileUi(newPlayer);
      newPlayer.currentTime(seekTime || 0);
    });
    setPlayer(newPlayer);

    return () => {
      if (!newPlayer.isDisposed()) {
        newPlayer.dispose();
      }
    };
  };

  useEffect(() => {
    if (player) {
      player.src(options.sources);
    }
  }, [player, options]);

  return (
    <div data-vjs-player>
      <div ref={handleVideoContainerRef} />
    </div>
  );
};

export default CustomVideoPlayer;
